(() => {
  const escapeHtml = (value) => String(value || '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const initialize = (root) => {
    if (!root || root.dataset.hdcatReady === 'true') return;

    const grid = root.querySelector('[data-hdcat-grid]');
    const cards = Array.from(root.querySelectorAll('[data-hdcat-card]'));
    const filters = Array.from(root.querySelectorAll('[data-hdcat-filter]'));
    const search = root.querySelector('[data-hdcat-search]');
    const sort = root.querySelector('[data-hdcat-sort]');
    const empty = root.querySelector('[data-hdcat-empty]');
    const compareTray = root.querySelector('[data-hdcat-compare-tray]');
    const compareCount = root.querySelector('[data-hdcat-compare-count]');
    const compareThumbs = root.querySelector('[data-hdcat-compare-thumbs]');
    const compareOpen = root.querySelector('[data-hdcat-compare-open]');
    const compareClear = root.querySelector('[data-hdcat-compare-clear]');
    const compareModal = root.querySelector('[data-hdcat-compare-modal]');
    const compareClose = root.querySelector('[data-hdcat-compare-close]');
    const compareTable = root.querySelector('[data-hdcat-compare-table]');
    let activeCategory = 'all';
    let selectedCompare = [];
    let compareReturnFocus = null;

    if (!grid || !cards.length) return;

    const applyFilters = () => {
      const query = (search?.value || '').trim().toLowerCase();
      let visible = 0;
      cards.forEach((card) => {
        const categoryMatch = activeCategory === 'all' || card.dataset.category === activeCategory;
        const queryMatch = !query || (card.dataset.title || '').toLowerCase().includes(query) || (card.dataset.cardLabel || '').toLowerCase().includes(query) || (card.dataset.highlights || '').toLowerCase().includes(query);
        card.hidden = !(categoryMatch && queryMatch);
        if (!card.hidden) visible += 1;
      });
      if (empty) empty.hidden = visible !== 0;
    };

    const sortCards = () => {
      const value = sort?.value || 'featured';
      const ordered = [...cards].sort((a, b) => {
        if (value === 'price-asc') return Number(a.dataset.priceValue || 0) - Number(b.dataset.priceValue || 0);
        if (value === 'price-desc') return Number(b.dataset.priceValue || 0) - Number(a.dataset.priceValue || 0);
        if (value === 'title') return (a.dataset.title || '').localeCompare(b.dataset.title || '');
        return Number(a.dataset.index || 0) - Number(b.dataset.index || 0);
      });
      ordered.forEach((card) => grid.appendChild(card));
      applyFilters();
    };

    const compareData = (card) => ({
      title: card.dataset.title || '',
      url: card.dataset.url || '#',
      image: card.dataset.image || '',
      price: card.dataset.price || '',
      category: card.dataset.category === 'dedicated' ? 'Dedicated scanner' : card.dataset.category === 'professional' ? 'Professional platform' : card.dataset.category === 'adapter' ? 'Adapter package' : card.dataset.category === 'kit' ? 'Expansion kit' : 'Heavy-duty product',
      label: card.dataset.cardLabel || '',
      compatibility: card.dataset.compatibility || '',
      highlights: card.dataset.highlights || ''
    });

    const updateCompareTray = () => {
      if (!compareTray || !compareOpen) return;
      compareTray.hidden = selectedCompare.length === 0;
      if (compareCount) compareCount.textContent = String(selectedCompare.length);
      compareOpen.disabled = selectedCompare.length < 2;
      compareOpen.setAttribute('aria-disabled', String(selectedCompare.length < 2));
      if (compareThumbs) {
        compareThumbs.innerHTML = selectedCompare.map((card) => {
          const item = compareData(card);
          return `<span class="hdcat__compare-thumb" title="${escapeHtml(item.title)}">${item.image ? `<img src="${escapeHtml(item.image)}" alt="">` : ''}</span>`;
        }).join('');
      }
    };

    const renderCompareTable = () => {
      if (!compareTable) return;
      const items = selectedCompare.map(compareData);
      const header = items.map((item) => `
        <th scope="col"><a class="hdcat__compare-product" href="${escapeHtml(item.url)}">${item.image ? `<img src="${escapeHtml(item.image)}" alt="">` : ''}<span><strong>${escapeHtml(item.title)}</strong><span>${escapeHtml(item.price)}</span></span></a></th>`).join('');
      const rows = [
        ['Product type', 'category'],
        ['Positioning', 'label'],
        ['Compatibility', 'compatibility'],
        ['Highlights', 'highlights']
      ].map(([label, key]) => `<tr><th scope="row">${escapeHtml(label)}</th>${items.map((item) => `<td>${escapeHtml(item[key])}</td>`).join('')}</tr>`).join('');
      compareTable.innerHTML = `<table class="hdcat__compare-table"><thead><tr><th></th>${header}</tr></thead><tbody>${rows}</tbody></table>`;
    };

    const closeCompare = () => {
      if (!compareModal) return;
      compareModal.hidden = true;
      compareModal.setAttribute('aria-hidden', 'true');
      if (compareReturnFocus?.focus) compareReturnFocus.focus();
      compareReturnFocus = null;
    };

    const openCompare = () => {
      if (!compareModal || selectedCompare.length < 2) return;
      compareReturnFocus = document.activeElement;
      renderCompareTable();
      compareModal.hidden = false;
      compareModal.setAttribute('aria-hidden', 'false');
      compareClose?.focus();
    };

    const clearCompare = () => {
      selectedCompare.forEach((card) => {
        const toggle = card.querySelector('[data-hdcat-compare-toggle]');
        if (toggle) toggle.checked = false;
      });
      selectedCompare = [];
      closeCompare();
      updateCompareTray();
    };

    filters.forEach((filter) => filter.addEventListener('click', () => {
      activeCategory = filter.dataset.hdcatFilter || 'all';
      filters.forEach((item) => {
        const selected = item === filter;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      applyFilters();
    }));
    search?.addEventListener('input', applyFilters);
    sort?.addEventListener('change', sortCards);

    cards.forEach((card) => {
      const toggle = card.querySelector('[data-hdcat-compare-toggle]');
      toggle?.addEventListener('change', () => {
        if (toggle.checked) {
          if (selectedCompare.length >= 3) {
            toggle.checked = false;
            window.alert('Choose up to three heavy-duty products to compare.');
            return;
          }
          if (!selectedCompare.includes(card)) selectedCompare.push(card);
        } else {
          selectedCompare = selectedCompare.filter((selected) => selected !== card);
        }
        updateCompareTray();
      });
    });

    compareOpen?.addEventListener('click', openCompare);
    compareClear?.addEventListener('click', clearCompare);
    compareClose?.addEventListener('click', closeCompare);
    compareModal?.addEventListener('click', (event) => {
      if (event.target === compareModal) closeCompare();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && compareModal && !compareModal.hidden) closeCompare();
    });

    root.dataset.hdcatReady = 'true';
    applyFilters();
    updateCompareTray();
  };

  const initializeAll = (scope = document) => scope.querySelectorAll('[data-hdcat-root]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
  else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
